import { Toilet } from '@/models/toilet'

export class PublicPlace{
  websiteId?:  string;
  toiletId?: string;
  sort?: number;
  toilet?: Toilet;

  constructor(params?: Partial<PublicPlace>) {
    Object.assign(this, params);
  }
}